import React, { useState, useEffect } from 'react';
import { Card,Button } from 'react-bootstrap';
import {createUserWithEmailAndPassword,
onAuthStateChanged,
signOut,
sendPasswordResetEmail} from "firebase/auth";
import {auth} from "../../firebase-config";
import {db} from "../../firebase-config";
import {app} from "../../firebase-config";
import { collection, getDocs, addDoc, updateDoc, deleteDoc, doc, Firestore, query, where } from "firebase/firestore";
import { async } from '@firebase/util';
import Dialog from "./Dialog";
import Cookies from 'universal-cookie';
// export default class Login extends Component {
const UserModule = (user) => {
    // console.log(user.userHome.uid);return;
    const cookies = new Cookies();
    const [isLoading, setLoading] = useState(true);

    const usersCollectionRef = collection(db,"users");
    const [name,setName] = useState("");
    const [lastname,setLastname] = useState("");
    const [email,setEmail] = useState("");
    const [address,setAddress] = useState("");
    const [uid,setUid] = useState("");
    const [users,setUsers] = useState({});

    const get_user = async (id) => {
        let userid = "";
        const q = query(usersCollectionRef,where("id", "==", id));
        const querySnapshot = await getDocs(q).then((res) => {
            res.forEach((doc) => {
                console.log(doc);
                // doc.data() is never undefined for query doc snapshots
                setUid(doc.id);
                setName(doc.data().name);
                setLastname(doc.data().lastname);
                setEmail(doc.data().email);
                setAddress(doc.data().address);
                setLoading(false);
            });
        });
    }
    useEffect(()=>{
        onAuthStateChanged(auth, (currentUser) => {
            setUsers(currentUser);
            console.log("aqui"+currentUser);
        });
    },[]);

    useEffect(() => {
        if(user.userHome.uid!=null){
            get_user(user.userHome.uid)
        }
    }, [user]); 

    const updateUser = async (id) => {
        setLoading(true);
        
        const userDoc = doc(db, "users", id);
        const newFields = { name: name, lastname: lastname, email: email, address: address };
        await updateDoc(userDoc, newFields).then((res)=>{
            setLoading(false);
        });
        get_user(id);
    };

    const deleteUsers = async (id) => {
        const userDoc = doc(db, "users", id);
        await deleteDoc(userDoc);
    };

    const deleteUser = async (id) => {
        if(users){
            setLoading(true);
            let userid = "";
            const q = query(usersCollectionRef,where("id", "==", id));
            const querySnapshot = await getDocs(q).then((res) => {
                res.forEach((doc) => {
                    userid = doc.id
                });
                deleteUsers(userid).then(function() {
                    users.delete();
                    alert("user deleted");
                }).catch(function(error) {
                    console.log(error.message);
                });
            });
        }else{
            window.location = "/";
        }
    }
        

    useEffect(()=>{
        if(isLoading){
            document.getElementById("data").style.display = "none";
            document.getElementById("loader").style.display = "block";
        }else{
            document.getElementById("data").style.display = "block";
            document.getElementById("loader").style.display = "none";
        }
    },[isLoading]);

    //CONFIRM
    const [dialog, setDialog] = useState({
        message: "",
        isLoading: false,
        //Update
        nameProduct: ""
      });

      const handleDialog = (message, isLoading, nameProduct) => {
        setDialog({
          message,
          isLoading,
          //Update
          nameProduct
        });
      };

      const handleDelete = () => {
        //Update
        handleDialog("Are you sure you want to delete permanently, you cannot undo?", true, user.userHome.user.email);
      };

      const areUSureDelete = (choose) => {
        if (choose) {
            deleteUser(user.userHome.user.uid)
            handleDialog("", false);
        } else {
            handleDialog("", false);
        }
      };

      const sendUsersReset = () => {
        sendPasswordResetEmail(auth,cookies.get('email')).then((res) => {
            alert("Email sent.");
        });
      }
    return (
      <div>
        <h2>User Information</h2>
        <div className='row' id="data">
            <div className='col-lg-6'>
            <Card>
                <Card.Body>
                    <Card.Title className='bg-info'>User Details</Card.Title>
                    <br></br>
                    <label>Name (Required)</label>
                    <input type="text" className='form-control' value={name}
                        onChange={(event)=>{setName(event.target.value)}} ></input>
                    <label>Lastname (Required)</label>
                    <input type="text" className='form-control' value={lastname}
                        onChange={(event)=>{setLastname(event.target.value)}} ></input>
                    <label>Email (Required)</label>
                    <input readOnly="yes" type="text" className='form-control' value={email}
                        onChange={(event)=>{setEmail(event.target.value)}} ></input>
                    {/* <label>Password (Required)</label>
                    <input type="password" className='form-control' ></input> */}
                    <label>Address</label>
                    <textarea className='form-control' cols="4" value={address} onChange={(event)=>{setAddress(event.target.value)}} ></textarea>
                    <br></br>
                    <Button variant="danger" className='pull-left' onClick={() => {handleDelete()}}
                    //onClick={()=>{deleteUser(user.userHome.user.uid)}}
                    >Delete Account</Button>
                    <Button variant="primary" className='pull-right' onClick={()=>{updateUser(uid)}}>Update Account</Button>
                    <Button variant="primary" className='pull-right' onClick={()=>{sendUsersReset()}}>Send Reset Password Email</Button>
                </Card.Body>
            </Card>
            </div>
        </div>
        <div className="loader-container" id="loader">
            <div className="loader"></div>
        </div>
        {dialog.isLoading && (
        <Dialog
          //Update
          nameProduct={dialog.nameProduct}
          onDialog={areUSureDelete}
          message={dialog.message}
        />
      )}
      </div>
      
    )
  // }
}

export default UserModule;